import { Injectable } from '@angular/core';
import { Http, Jsonp } from '@angular/http';
import 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { VersionService } from '../services/version.service';
import { Config } from '../classes/config';

@Injectable()
export class PrestatieService {

  constructor(private _http: Http, private _jsonp: Jsonp, private ver: VersionService) { }

  get(targetId: number) {
    return this._http.get(
      `${Config.apiUrl}/prestatie?versionId=${this.ver.activeVersion()}&q=&productgroep=${targetId.toString()}&callback=JSONP_CALLBACK`
    ).map(resp => resp.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/prestatie.service.ts